import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { EASE } from "./Reveal";

export const Preloader = () => {
  const [n, setN] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / 1400);
      setN(Math.round((1 - Math.pow(1 - p, 3)) * 100));
      if (p < 1) raf = requestAnimationFrame(tick);
      else setTimeout(() => setDone(true), 200);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-navy-deep text-white"
          exit={{ clipPath: "inset(0% 0% 100% 0%)" }}
          initial={{ clipPath: "inset(0% 0% 0% 0%)" }}
          transition={{ duration: 0.9, ease: EASE }}
          data-testid="preloader"
        >
          <motion.div initial={{ scale: 0.6, opacity: 0, rotate: -12 }} animate={{ scale: 1, opacity: 1, rotate: 0 }} transition={{ duration: 0.9, ease: EASE }} className="grid h-28 w-28 place-items-center rounded-[28px] bg-white shadow-[0_0_80px_-10px_rgba(217,181,86,0.55)]">
            <img src="/zenura-logo.png" alt="" className="h-20 w-20 object-contain" />
          </motion.div>
          <p className="mt-8 font-mono text-xs uppercase tracking-[0.5em] text-slate-300">Zenura Metals</p>
          <div className="mt-6 h-px w-48 overflow-hidden bg-white/15">
            <div className="h-full bg-gold-light" style={{ width: `${n}%` }} />
          </div>
          <p className="absolute bottom-8 right-8 font-display text-7xl font-extrabold tabular-nums text-white/90 sm:text-9xl">{n}</p>
          <p className="absolute bottom-10 left-8 font-mono text-[11px] uppercase tracking-[0.3em] text-slate-400">Sourcing the world's metal</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
